/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientTeamRole } from './';
import {
    ClientTeamRoleFromJSON,
    ClientTeamRoleFromJSONTyped,
    ClientTeamRoleToJSON,
} from './';
import type { OrganizationRole } from './';
import {
    OrganizationRoleFromJSON,
    OrganizationRoleFromJSONTyped,
    OrganizationRoleToJSON,
} from './';
import type { Photo } from './';
import {
    PhotoFromJSON,
    PhotoFromJSONTyped,
    PhotoToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyMemberResource
 */
export interface ClientCompanyMemberResource {
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    fullName?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCompanyMemberResource
     */
    email: string;
    /**
     * 
     * @type {ClientTeamRole}
     * @memberof ClientCompanyMemberResource
     */
    role?: ClientTeamRole;
    /**
     * 
     * @type {ClientTeamRole}
     * @memberof ClientCompanyMemberResource
     */
    clientTeamRole?: ClientTeamRole;
    /**
     * 
     * @type {OrganizationRole}
     * @memberof ClientCompanyMemberResource
     */
    organizationRole?: OrganizationRole;
    /**
     * 
     * @type {Photo}
     * @memberof ClientCompanyMemberResource
     */
    photo?: Photo;
    /**
     * 
     * @type {number}
     * @memberof ClientCompanyMemberResource
     */
    pendingMissionsCount?: number;
}

/**
 * Check if a given object implements the ClientCompanyMemberResource interface.
 */
export function instanceOfClientCompanyMemberResource(value: object): value is ClientCompanyMemberResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function ClientCompanyMemberResourceFromJSON(json: any): ClientCompanyMemberResource {
    return ClientCompanyMemberResourceFromJSONTyped(json, false);
}

export function ClientCompanyMemberResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyMemberResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
        'email': json['email'],
        'role': json['role'] == null ? undefined : ClientTeamRoleFromJSON(json['role']),
        'clientTeamRole': json['clientTeamRole'] == null ? undefined : ClientTeamRoleFromJSON(json['clientTeamRole']),
        'organizationRole': json['organizationRole'] == null ? undefined : OrganizationRoleFromJSON(json['organizationRole']),
        'photo': json['photo'] == null ? undefined : PhotoFromJSON(json['photo']),
        'pendingMissionsCount': json['pendingMissionsCount'] == null ? undefined : json['pendingMissionsCount'],
    };
}

export function ClientCompanyMemberResourceToJSON(value?: ClientCompanyMemberResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'fullName': value['fullName'],
        'email': value['email'],
        'role': ClientTeamRoleToJSON(value['role']),
        'clientTeamRole': ClientTeamRoleToJSON(value['clientTeamRole']),
        'organizationRole': OrganizationRoleToJSON(value['organizationRole']),
        'photo': PhotoToJSON(value['photo']),
        'pendingMissionsCount': value['pendingMissionsCount'],
    };
}

